import {
  removeNullAttributes,
  queryStringFromObject,
  authHeader,
  handleResponse,
  handleWithClearErrorResponse,
  handleNoContentResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function getSaVersionList(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const { sortOrder, sortBy } = { ...queryParams };
  delete queryParams.sortOrder;
  delete queryParams.sortBy;

  const sortQuery =
    sortOrder && sortBy
      ? `&sort=${
          sortBy === "uploadedDate" ? "uploadedDateInMillis" : sortBy
        }:${sortOrder}`
      : "";

  const queryObject = removeNullAttributes(queryParams);
  const query = queryStringFromObject(queryObject);

  const endPoint = `/api/admin/v1/version-files/analyzers/sa?${query}${sortQuery}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function uploadSaVersion(formData) {
  const requestOptions = {
    method: "POST",
    headers: {
      // "Content-Type": "multipart/form-data",
      ...authHeader(),
    },
    body: formData,
  };

  const endPoint = `/api/admin/v1/version-files/analyzers/sa`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function deleteSaVersion(queryParams) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const endPoint = `/api/admin/v1/version-files/analyzers/sa/${queryParams}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleNoContentResponse)
    .then((data) => {
      return data;
    });
}
function showSaVersion(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const { version } = queryParams;
  const endPoint = `/api/admin/v1/version-files/analyzers/sa/${version}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

export const saVersionListService = {
  getSaVersionList,
  uploadSaVersion,
  deleteSaVersion,
  showSaVersion,
};
